"use client";

import TypoGraphy from "@/typography";
import Button from "@/uicomponents/Button";
import useViewType from "@/utils/Hooks/useViewType";
import { RouteStrings } from "@/utils/routestrings";
import { useRouter } from "next/navigation";
import { projectImages } from "public/Assets/Images";
import { useState } from "react";
const SubTopicList = ({
  data
}: any) => {
  const [toggle, settoggle] = useState(false);
  const isMobile = useViewType();
  const {
    push
  } = useRouter();
  return <div className="sub_topic_wrapper" onClick={() => settoggle(!toggle)} data-sentry-component="SubTopicList" data-sentry-source-file="index.tsx">
        <div className="click_content">
          <div className="text_content">
            <TypoGraphy text={"SUB - TOPIC 1"} variant={isMobile ? "Mobile/Caption/R | 12 | 120 | 6%" : "Desktop/Caption/14 | 120 | | 120 | 10% Letter Spacing"} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
            <TypoGraphy tagName="h3" text={data.subTopicName} variant={isMobile ? "Mobile/Body 1/M | 16 | 160" : "Desktop/Heading 1/M | 20 |120"} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
          </div>
          <img src={projectImages.faqArrowDown} alt="down" loading='lazy' style={{
        transform: toggle ? "rotate(180deg)" : ""
      }} />
        </div>
        {toggle && <div className="description_wrapper">
            <div className="list_content">
              {data.articles.data.map((article: any, index: number) => {
          return <a href={RouteStrings.DYNAMICROUTE(article.attributes.title, 'ARTICLE', article.id)} onClick={e => {
            e.preventDefault();
            push(RouteStrings.DYNAMICROUTE(article.attributes.title, 'ARTICLE', article.id));
          }}>
                  <div className="article_info_wrapper">
                    <div className="article_text">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M13.1677 1.84207C12.826 1.5004 12.2344 1.73373 12.2344 2.20873V5.11707C12.2344 6.33373 13.2677 7.34207 14.526 7.34207C15.3177 7.3504 16.4177 7.3504 17.3594 7.3504C17.8344 7.3504 18.0844 6.79207 17.751 6.45873C16.551 5.2504 14.401 3.0754 13.1677 1.84207Z" fill="#B3B5BC" />
                        <path d="M17.082 8.49492H14.6737C12.6987 8.49492 11.0904 6.88659 11.0904 4.91159V2.50326C11.0904 2.04492 10.7154 1.66992 10.257 1.66992H6.7237C4.15703 1.66992 2.08203 3.33659 2.08203 6.31159V13.6949C2.08203 16.6699 4.15703 18.3366 6.7237 18.3366H13.2737C15.8404 18.3366 17.9154 16.6699 17.9154 13.6949V9.32825C17.9154 8.86992 17.5404 8.49492 17.082 8.49492ZM9.58203 14.7949H6.2487C5.90703 14.7949 5.6237 14.5116 5.6237 14.1699C5.6237 13.8283 5.90703 13.5449 6.2487 13.5449H9.58203C9.9237 13.5449 10.207 13.8283 10.207 14.1699C10.207 14.5116 9.9237 14.7949 9.58203 14.7949ZM11.2487 11.4616H6.2487C5.90703 11.4616 5.6237 11.1783 5.6237 10.8366C5.6237 10.4949 5.90703 10.2116 6.2487 10.2116H11.2487C11.5904 10.2116 11.8737 10.4949 11.8737 10.8366C11.8737 11.1783 11.5904 11.4616 11.2487 11.4616Z" fill="#B3B5BC" />
                      </svg>
                      <TypoGraphy text={article.attributes.title} variant={isMobile ? "Mobile/Body 2" : "Desktop/Body 1/R | 16 |120"} />
                    </div>
                    <div className="article_minutes">
                      <TypoGraphy text={`${article.attributes.minuteRead} mins`} variant={isMobile ? "Mobile/Caption/R | 12 | 160" : "Mobile/Body 2/R | 14 | 120"} />
                    </div>
                  </div>
                  </a>;
        })}
            </div>
            <Button text="See All" textColor="black" textVariant={isMobile ? "Mobile/Body 2/M | 14 | 120" : "Desktop/Body 1/M | 16 |120"} borderColor="black" variant="NormalVariant" backgroundColor="white" styles={{
        paddingTop: "15px"
      }} clickHandler={() => push(RouteStrings.DYNAMICROUTE(data.subTopicName, "SUBTOPIC", data.id))} />
          </div>}
      </div>;
};
export default SubTopicList;